import React, { useCallback } from 'react';
import { styled } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl/src/index.tsx';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages';

type Props = {
	href: string;
};

const ExportCsvButton = ({ href }: Props) => {
	const { formatMessage } = useIntl();
	// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
	const handleClick = useCallback((_, analyticsEvent: UIAnalyticsEvent) => {
		fireUIAnalytics(analyticsEvent, 'exportCsvButton');
	}, []);

	return (
		<CsvButtonContainer data-test-id="servicedesk-kb-requests-reports.ui.export-csv.export-csv">
			<Button appearance="default" href={href} onClick={handleClick}>
				{formatMessage(messages.exportCsvButtonLabel)}
			</Button>
		</CsvButtonContainer>
	);
};

export default ExportCsvButton;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CsvButtonContainer = styled.div({
	marginLeft: 'auto',
	paddingRight: token('space.400', '32px'),
});
